module.exports = __webpack_public_path__ + "img/microplastics-process-10.5a34777e.png";